import React from 'react';
import { Section, preloader } from 'spectacle-ppa';

import videoSlide from '../../baseSlides/videoSlide';
import balloonSlide from '../../baseSlides/balloonSlide';
import headingSlide from '../../baseSlides/headingSlide';

import imagePPALogo from '../../images/logo_ppa.png';
import esGooberGoofySmile from '../../images/characters/esmeralda_goober_goofy_smile.png';
import ianSaraSilly from '../../images/characters/ian_sara_silly.png';
import esGooberProud from '../../images/characters/esmeralda_goober_proud.png';

import MarkdownScript from 'helpers/markdownScript';
import markdownFile from './ending.md';

const md = new MarkdownScript(markdownFile);

export function preloadEnding() {
  preloader([
    esGooberGoofySmile,
    ianSaraSilly,
    esGooberProud,
    imagePPALogo
  ]);
}

function endingSection({ regionData }) {
  return (
    <Section id="ending">

      {/* Ian and Sara Goodbye */}
      {videoSlide({
        id: 'ian-sara-goodbye',
        youTubeId: md.getSectionMetadata('Ian and Sara Goodbye', 'YouTube', regionData),
        notes: md.getSubSectionAsHtml('Ian and Sara Goodbye', 'Notes', false, regionData)
      })}

      {/* Time to see who won! */}
      {balloonSlide({
        id: 'announce-winners',
        characterSide: 'right',
        characterImage: ianSaraSilly,
        html: md.getSubSectionAsHtml('Announce Winners', 'Content', false, regionData),
        notes: md.getSubSectionAsHtml('Announce Winners', 'Notes', false, regionData)
      })}

      {/* You're now all Planet Protectors */}
      {balloonSlide({
        id: 'planet-protectors',
        characterSide: 'left',
        characterImage: esGooberProud,
        html: md.getSubSectionAsHtml('Planet Protectors', 'Content', false, regionData),
        notes: md.getSubSectionAsHtml('Planet Protectors', 'Notes', false, regionData)
      })}

      {/* You've completed all the levels */}
      {headingSlide({
        id: 'completed',
        beforeImage: imagePPALogo,
        heading: 'Zero Heroes',
        subHeading: 'All levels completed!!!',
        notes: md.getSubSectionAsHtml('All Levels Completed', 'Notes', false, regionData),
        bgColor: 'black'
      })}

    </Section>
  );
}

export default endingSection;



// WEBPACK FOOTER //
// ./programs/zeroHeroes/sections/95_ending/endingSection.jsx